import { AtcCodeContentModel } from './atcCodeContentModel';

export class ATCCodeModel {
  public atcCodeId: number;
  public parentId: number;
  public levelNo: number;
  public orderNo: number;
  public atcCode: string;
  public hasChildren: boolean;
  public atcCodeContent: Array<AtcCodeContentModel>;
}